import React, { useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import api from "../../../Axios";

const AddStudentForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    rollNumber: "",
    batch: "",
    course: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Sending form data to the server
      const response = await api.post(`${process.env.REACT_APP_BASE_URL}/api/v1/students`, formData);

      toast.success("Student added successfully!");
      setFormData({
        name: "",
        rollNumber: "",
        batch: "",
        course: "",
      });
    } catch (error) {
      toast.error(
        error.response?.data?.message || "An error occurred. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 p-6">
      <motion.div
        className="bg-white shadow-xl rounded-lg p-10 w-full max-w-3xl"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <h2
          className="text-3xl font-semibold text-white text-center py-4 mb-8 rounded-t-lg"
          style={{ backgroundColor: "#00BFA5" }}
        >
          Add New Student
        </h2>
        <form onSubmit={handleSubmit}>
          {["name", "rollNumber", "batch", "course"].map((field) => (
            <div className="mb-6" key={field}>
              <label
                htmlFor={field}
                className="block text-gray-600 text-sm font-medium mb-2 capitalize"
              >
                {field === "rollNumber" ? "Roll Number" : field}
              </label>
              <input
                type="text"
                id={field}
                name={field}
                value={formData[field]}
                onChange={handleChange}
                placeholder={`Enter ${field === "rollNumber" ? "Roll Number" : field}`}
                required
                className="w-full px-6 py-4 border border-gray-300 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#00BFA5]"
              />
            </div>
          ))}
          <motion.button
            type="submit"
            className={`w-48 mx-auto py-3 rounded-lg font-semibold shadow-md focus:outline-none focus:ring-2 ${
              loading
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-[#00BFA5] hover:bg-[#00BFA5] text-white"
            }`}
            disabled={loading}
            whileTap={{ scale: 0.98 }}
            style={{ fontSize: "1rem" }}
          >
            {loading ? "Adding..." : "Add Student"}
          </motion.button>
        </form>
      </motion.div>
      <ToastContainer />
    </div>
  );
};

export default AddStudentForm;
